<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="510"
    height="480"
    viewBox="0 0 134.938 127"
    role="img"
    :aria-label="t('icons.welcome.ariaLabel')"
  >
    <g transform="matrix(0 0 0 0 0 264583.33)">
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="64.823"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="64.823"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="78.052"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="78.052"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-9.26"
        cy="78.052"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="78.052"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-9.26"
        cy="91.281"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="91.281"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-41.01"
        cy="91.281"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-25.135"
        cy="91.281"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="104.51"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="54.24"
        cy="104.51"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="104.51"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="104.51"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="117.74"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="117.74"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-25.135"
        cy="117.74"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-9.26"
        cy="117.74"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="54.24"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="70.115"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="144.198"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="144.198"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-9.26"
        cy="144.198"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="144.198"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="70.115"
        cy="157.427"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="85.99"
        cy="157.427"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="157.427"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="54.24"
        cy="157.427"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="38.365"
        cy="170.656"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="54.24"
        cy="170.656"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="170.656"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="170.656"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="6.615"
        cy="183.885"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="22.49"
        cy="183.885"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-25.135"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="-9.26"
        cy="130.969"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="54.24"
        cy="117.74"
        r="3.969"
      />
      <circle
        style="fill: #000; stroke-linecap: round; stop-color: #000"
        cx="70.115"
        cy="117.74"
        r="3.969"
      />
    </g>
    <g transform="translate(-10.583 -10.583)">
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="78.052"
        cy="14.552"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="93.927"
        cy="14.552"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="78.052"
        cy="27.781"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="93.927"
        cy="27.781"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="46.302"
        cy="27.781"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="62.177"
        cy="27.781"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="46.302"
        cy="41.01"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="62.177"
        cy="41.01"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="14.552"
        cy="41.01"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="30.427"
        cy="41.01"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="30.427"
        cy="67.469"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="125.677"
        cy="80.698"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="125.677"
        cy="107.156"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="141.552"
        cy="107.156"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="93.927"
        cy="107.156"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="109.802"
        cy="107.156"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="93.927"
        cy="120.385"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="109.802"
        cy="120.385"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="62.177"
        cy="120.385"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="78.052"
        cy="120.385"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="62.177"
        cy="133.615"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="78.052"
        cy="133.615"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="30.427"
        cy="80.698"
        r="3.969"
      />
      <circle
        style="
          fill: #f5cc5b;
          fill-opacity: 1;
          stroke-width: 0.529167;
          stroke-linecap: round;
          stop-color: #000;
        "
        cx="125.677"
        cy="67.469"
        r="3.969"
      />
    </g>
    <path
      d="M76.549 64.342H62.478v14.07h14.07zm4.69 23.452v4.69H57.787v-4.69zm0-28.142v23.451H57.787V59.652Zm23.452 28.142v4.69H85.929v-4.69zm0-9.381v4.69H85.929v-4.69zm0-9.38v4.69H85.929v-4.69zm0-9.381v4.69H85.929v-4.69ZM48.407 94.829V59.652h-4.69v35.177a2.362 2.362 0 0 0 2.345 2.345 2.362 2.362 0 0 0 2.345-2.345zm60.974 0V54.961H53.097V94.83c0 .806-.147 1.612-.403 2.345h54.342a2.362 2.362 0 0 0 2.345-2.345zm4.69-44.558v44.558a7.037 7.037 0 0 1-7.035 7.036H46.062a7.037 7.037 0 0 1-7.036-7.036V54.961h9.38v-4.69z"
      style="fill: #262453; fill-opacity: 1; stroke-width: 0.264583"
      transform="translate(-10.583 -10.583)"
    />
  </svg>
</template>

<script lang="ts" setup>
/**
 * WelcomeIcon displays a decorative icon for welcome messages
 *
 * Uses internal i18n for:
 * - Icon accessibility: icons.welcome.ariaLabel
 *
 * @component WelcomeIcon
 */
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
